<script>
    export default {
        props: [
            'widget', 'initLang'
        ],
        data() {
            return {
                lang: this.initLang,
            }
        },
        mounted: function(){
            let dashboardWidget = this;

            dashboardWidget.lang = $.extend({}, dashboardWidget.$parent.lang, dashboardWidget.lang);
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/components/admin/dashboards/dashboardWidget.vue